import { Transition } from "@headlessui/react"
import { Form, Head } from "@inertiajs/react"

import { FormField, FormFields } from "@/components/form-field"
import HeadingSmall from "@/components/heading-small"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import AppLayout from "@/layouts/app-layout"
import SettingsLayout from "@/layouts/settings/layout"
import { settingsPasswordPath } from "@/routes"
import type { BreadcrumbItem } from "@/types"

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Password settings",
    href: settingsPasswordPath(),
  },
]

export default function Password() {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title={breadcrumbs[breadcrumbs.length - 1].title} />

      <SettingsLayout>
        <div className="space-y-6">
          <HeadingSmall
            title="Password"
            description="A long, random password keeps your account secure."
          />

          <Form
            method="put"
            action={settingsPasswordPath()}
            options={{
              preserveScroll: true,
            }}
            resetOnError
            resetOnSuccess
          >
            {({ errors, processing, recentlySuccessful }) => (
              <FormFields>
                <FormField
                  label="Current password"
                  htmlFor="current_password"
                  error={errors.current_password}
                >
                  <Input
                    id="current_password"
                    name="current_password"
                    type="password"
                    autoComplete="current-password"
                    placeholder="Current password"
                    required
                  />
                </FormField>

                <FormField
                  label="New password"
                  htmlFor="password"
                  error={errors.password}
                >
                  <Input
                    id="password"
                    name="password"
                    type="password"
                    autoComplete="new-password"
                    placeholder="New password"
                    required
                  />
                </FormField>

                <FormField
                  label="Confirm password"
                  htmlFor="password_confirmation"
                  error={errors.password_confirmation}
                >
                  <Input
                    id="password_confirmation"
                    name="password_confirmation"
                    type="password"
                    autoComplete="new-password"
                    placeholder="Confirm password"
                    required
                  />
                </FormField>

                <div className="flex items-center gap-4">
                  <Button disabled={processing}>Save password</Button>

                  <Transition
                    show={recentlySuccessful}
                    enter="transition ease-in-out"
                    enterFrom="opacity-0"
                    leave="transition ease-in-out"
                    leaveTo="opacity-0"
                  >
                    <p className="text-sm text-neutral-600">Saved</p>
                  </Transition>
                </div>
              </FormFields>
            )}
          </Form>
        </div>
      </SettingsLayout>
    </AppLayout>
  )
}
